import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ProgressProvider } from './store/ProgressContext'
import { getNativeProgressPersistence, initializeNativeProgressPersistence, subscribeNativePersistence } from './services/nativeProgressPersistence'
import { registerOfflineSupport } from './services/offline'
import './styles.css'

const root = ReactDOM.createRoot(document.getElementById('root')!)

function NativeSaveNotice() {
  const [failed, setFailed] = React.useState(false)
  const [retrying, setRetrying] = React.useState(false)
  React.useEffect(() => subscribeNativePersistence(setFailed), [])
  if (!failed) return null
  return <aside role="alert" className="fixed inset-x-3 top-[max(12px,env(safe-area-inset-top))] z-[100] mx-auto max-w-xl rounded-2xl bg-amber-50 p-4 text-amber-950 shadow-soft">
    <p>本机进度备份暂未成功，当前学习记录仍保留。请请家长重试保存，暂时不要卸载 App。</p>
    <button className="quiet-button mt-2" disabled={retrying} onClick={() => {
      setRetrying(true)
      void getNativeProgressPersistence()?.retry().finally(() => setRetrying(false))
    }}>{retrying ? '正在保存…' : '重试保存'}</button>
  </aside>
}

async function start() {
  root.render(<div role="status" className="grid min-h-dvh place-items-center bg-garden-50 text-garden-900">正在打开小花园…</div>)
  try {
    await initializeNativeProgressPersistence()
    root.render(<React.StrictMode><NativeSaveNotice /><ProgressProvider><App /></ProgressProvider></React.StrictMode>)
  } catch {
    // Do not initialize ProgressProvider on a failed native read: its save effect
    // would otherwise overwrite the unread record with a new child's progress.
    root.render(<main className="mx-auto flex min-h-dvh max-w-lg flex-col justify-center gap-4 px-6 text-garden-900">
      <h1 className="text-2xl font-black">请家长帮忙打开小花园</h1>
      <p role="alert">本机学习记录暂时无法读取。原有记录没有被清除，请稍后重试，不要卸载 App。</p>
      <button className="quiet-button bg-garden-100" onClick={() => void start()}>重试读取</button>
    </main>)
  }
}

void start()
if (import.meta.env.PROD) void registerOfflineSupport().catch(() => {
  // The online app remains usable; the parent panel reports offline availability.
})
